/* eslint-disable */
// @ts-nocheck

import moment from 'moment'
import { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import useServer from '../../../api/useServerMain'
import Input from '../../../components/forms/BasicInput'
import CurrencyInput from '../../../components/forms/CurrencyInput'
import SingleRadio from '../../../components/forms/SingleRadio'
import Toggle from '../../../components/forms/Toggle'
import Button from '../../../components/misc/Button'
import { useAppSelector } from '../../../store/hooks'
import { formatCalendar } from '../../../utils/helpers'
import { DetailProductContext } from '../DetailProductContainer'

const Promotions = () => {
  const { denyRoles } = useServer()

  const { product, updateProduct, isFetching } =
    useContext(DetailProductContext)
  const { handleSubmit, control, watch, unregister, setValue } = useForm()

  const [onSale, setOnSale] = useState(product?.onSale ?? false)

  const { business } = useAppSelector((state) => state.init)

  const saleType = watch('onSaleType')

  useEffect(() => {
    if (!onSale) {
      unregister(['onSalePrice', 'onSaleType', 'onSaleDiscountAmount'])
      setValue('onSalePrice', null)
      setValue('onSaleDiscountAmount', null)
      setValue('onSaleType', null)
    }
  }, [onSale])

  useEffect(() => {
    switch (watch('onSaleType')) {
      case 'fixed':
        unregister('onSaleDiscountAmount')
        setValue('onSaleDiscountAmount', null)
        break
      case 'percent':
        unregister('onSalePrice')
        setValue('onSalePrice', null)
        break
      default:
        unregister('onSaleDiscountAmount')
        setValue('onSaleDiscountAmount', null)
        break
    }
  }, [saleType])

  const newArrival = watch('newArrival')

  useEffect(() => {
    if (newArrival) {
      setValue('newArrivalAt', moment().add(7, 'days').format('YYYY-MM-DD'))
    }
  }, [newArrival])

  //----------------------------------------------------------------

  const onSubmit: SubmitHandler<Record<string, any>> = (data) => {
    const { onSaleType, onSale } = data

    if (onSale) {
      if (onSaleType === null) {
        toast.error(
          'Seleccione si la oferta es por porciento o por precio fijo'
        )
      } else {
        if (onSaleType === 'fixed') {
          const onSalePrice = {
            amount: data.onSalePrice?.price,
            codeCurrency: data.onSalePrice.codeCurrency,
          }

          updateProduct!(product?.id, { ...data, onSalePrice })
        } else {
          updateProduct!(product?.id, data)
        }
      }
    } else {
      updateProduct!(product?.id, data)
    }
  }

  return (
    <form
      className="grid grid-cols-1 place-content-between"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="grid h-[34rem] grid-cols-3 items-start rounded-md border border-slate-300 p-7">
        <Toggle
          control={control}
          defaultValue={product?.suggested}
          name="suggested"
          title="Sugerencia de la casa"
        />

        <div className="flex flex-col gap-0">
          <Toggle
            control={control}
            defaultValue={product?.newArrival}
            name="newArrival"
            title="Nuevo arribo"
          />
          {product?.newArrival && (
            <p className="text-xs text-gray-400">{`* Hasta: ${formatCalendar(
              product.newArrivalAt
            )}`}</p>
          )}
        </div>
        <div>
          <Toggle
            changeState={setOnSale}
            control={control}
            defaultValue={product?.onSale}
            name="onSale"
            title="Producto en oferta"
          />

          {onSale && (
            <>
              <div className="inline-flex gap-2 p-5">
                <SingleRadio
                  checked={product?.onSaleType === 'fixed'}
                  control={control}
                  label="Por precio fijo"
                  name="onSaleType"
                  onChangeFunction={() => {
                    setValue('onSaleType', 'fixed')
                  }}
                  value="fixed"
                />
                <SingleRadio
                  checked={product?.onSaleType === 'percent'}
                  control={control}
                  label="Por porciento"
                  name="onSaleType"
                  onChangeFunction={() => {
                    setValue('onSaleType', 'percent')
                  }}
                  value="percent"
                />
              </div>
              {(
                saleType
                  ? saleType === 'fixed'
                  : product?.onSaleType === 'fixed'
              ) ? (
                <CurrencyInput
                  byDefault={
                    product?.onSalePrice
                      ? {
                          ...product.onSalePrice,
                          price: product.onSalePrice.amount,
                        }
                      : undefined
                  }
                  control={control}
                  currencies={
                    business?.availableCurrencies.map(
                      (currency) => currency.code
                    ) ?? []
                  }
                  label="Precio *"
                  name="onSalePrice"
                  rules={{ required: 'Campo requerido' }}
                />
              ) : (
                  saleType
                    ? saleType === 'percent'
                    : product?.onSaleType === 'percent'
                ) ? (
                <div className="relative">
                  <Input
                    control={control}
                    defaultValue={product?.onSaleDiscountAmount}
                    label="Porciento *"
                    name="onSaleDiscountAmount"
                    rules={{ required: '* Campo requerido' }}
                    type="number"
                  />
                  <span className="absolute right-3 top-8 font-semibold text-gray-600">
                    %
                  </span>
                </div>
              ) : (
                ''
              )}
            </>
          )}
        </div>
      </div>

      {denyRoles(['AUDITOR']) && (
        <div className="flex w-full justify-end p-5 pr-0">
          <Button
            color="slate-600"
            disabled={isFetching}
            loading={isFetching}
            name="Actualizar"
            type="submit"
          />
        </div>
      )}
    </form>
  )
}

export default Promotions
